import { IconSpriteArrowsCircleThick, IconSpriteEnvelopeFilled, IconSpriteHeartFilled } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { LeadSignInTemplatePropsInterface } from 'common/module/lead/sign-in/template-props.interface';

export const LeadSignInTemplate: FunctionalComponent<LeadSignInTemplatePropsInterface> = (
  props
): preact.JSX.Element => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className='autoregister'>
      <div className='autoregister__title'>{i18nTranslate('Sign in for a better search experience')}</div>
      <div className='autoregister__feature-area'>
        <div className='autoregister__feature-list'>
          <IconSpriteHeartFilled className='autoregister__icon' />
          <div className='autoregister__feature-text'>{i18nTranslate('View all your saved properties')}</div>
        </div>
        <div className='autoregister__feature-list'>
          <IconSpriteEnvelopeFilled className='autoregister__icon' />
          <div className='autoregister__feature-text'>{i18nTranslate('Track all your communications with agents')}</div>
        </div>
        <div className='autoregister__feature-list'>
          <IconSpriteArrowsCircleThick className='autoregister__icon' />
          <div className='autoregister__feature-text'>{i18nTranslate('Sync across all of your devices')}</div>
        </div>
      </div>
      <div className='autoregister__button-area'>
        <div className='button autoregister__signin-button' onClick={props.onClickSignIn}>
          {i18nTranslate('Sign in')}
        </div>
        {!props.isNotNowButtonHidden && (
          <div className='autoregister__not-now-button' onClick={props.onClickNotNow}>
            {i18nTranslate('Not now')}
          </div>
        )}
      </div>
    </div>
  );
};
